import styles from '../includes/vscode-select/styles.js';

export default styles;
